import { Properties } from '../../utility/Types/commonTypes';
import {
    UPDATE_PANEL_PROPERTIES,
    HIDE_PRIMARY_PANEL,
    SHOW_PRIMARY_PANEL,
    TOGGLE_PRIMARY_PANEL_COMPACT,
    HIDE_SECONDARY_PANEL,
    SHOW_SECONDARY_PANEL,
    TOGGLE_SECONDARY_PANEL_COMPACT
} from './Types';

export const updatePanelProperties = (name: string, properties: Properties) => ({ type: UPDATE_PANEL_PROPERTIES, name, properties });
export const hidePrimaryPanel = () => ({ type: HIDE_PRIMARY_PANEL });
export const showPrimaryPanel = (name: string) => ({ type: SHOW_PRIMARY_PANEL, name });
export const togglePrimaryPanelCompact = () => ({ type: TOGGLE_PRIMARY_PANEL_COMPACT });
export const hideSecondaryPanel = () => ({ type: HIDE_SECONDARY_PANEL });
export const showSecondaryPanel = (name: string) => ({ type: SHOW_SECONDARY_PANEL, name });
export const toggleSecondaryPanelCompact = () => ({ type: TOGGLE_SECONDARY_PANEL_COMPACT });